import { z } from 'zod';
import type { ActiveOrganizationSignatureSummary } from '../legal-organization-signature-summary.types';
import { NonEmptyStringSchema } from './common.schemas';

export const ActiveOrganizationSignatureSummarySchema: z.ZodType<ActiveOrganizationSignatureSummary> =
    z.discriminatedUnion('summary_kind', [
        z.object({ summary_kind: z.literal('not_applicable') }).strict(),
        z
            .object({
                summary_kind: z.literal('organization'),
                organization_uuid: z.string().uuid(),
                organization_name: NonEmptyStringSchema,
                awaiting_signature_count: z.number().int().nonnegative(),
                can_sign: z.boolean(),
            })
            .strict(),
    ]);
